import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

import { useNotifications } from "@/store";

export interface INotification {
  date: string;
  title: string;
  content: string;
  read: boolean;
}

const Notification: React.FC = () => {
  const { t } = useTranslation();

  const listRef = useRef<HTMLDivElement>(null);

  const { notifications, loadMoreNotifications } = useNotifications();

  const handleScroll = () => {
    const list = listRef.current;
    if (list) {
      const isBottom =
        list.scrollTop + list.clientHeight >= list.scrollHeight - 30;
      if (isBottom) {
        loadMoreNotifications();
      }
    }
  };

  return (
    <div className="rounded-3xl py-3 min-w-72  lg:min-w-[400px] w-full max-w-xl font-alata">
      <h3 className="text-xl dark:text-vs-dark-text-lighter px-3">
        {t("notifications")}
      </h3>
      <div
        onScroll={handleScroll}
        ref={listRef}
        className="space-y-3 px-3 mt-5 max-h-[400px] overflow-y-auto"
      >
        {notifications?.length > 0 ? (
          notifications.map((notification, index) => (
            <div
              className="bg-[#F0F3FC] dark:bg-vs-dark-background dark:text-vs-dark-text py-3 px-3 rounded-xl relative"
              key={index}
            >
              <small className="text-[#7E8CBE] text-xs">
                {dayjs(notification.create_time).format("DD/MM/YYYY HH:mm")}
              </small>
              <h5 className="mt-3">{notification.title}</h5>
              <p className="text-sm text-[#22538D] mt-3">
                {notification.message}
              </p>
              {!notification.is_read && (
                <div className="rounded-full bg-rose-400 w-2 h-2 absolute top-3 right-3" />
              )}
            </div>
          ))
        ) : (
          <div className="bg-[#F0F3FC] dark:bg-vs-dark-background py-3 px-3 rounded-xl relative">
            <p className="text-sm text-[#22538D] dark:text-vs-dark-text">
              {t("emptyNotification")}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Notification;
